import { PublicClientApplication } from "@azure/msal-browser"
import { msalConfig } from "./auth/authConfig"

export const msalInstance = new PublicClientApplication(msalConfig)
